import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterState } from '@angular/router';
import { TooltipService } from '../../widgets/tooltip.service';
import { HumanResources, AuthenticationService, AuthenticatedIdentity, Academic, AcademicTitleId} from '../../domain';

@Component({
	selector: 'review-and-compile',
	templateUrl: './review-and-compile.component.html',
	styleUrls: ['./review-and-compile.component.scss']
})
export class ReviewAndCompileComponent {
	private activeRoute: RouterState;
	meritAndPromotionHR = HumanResources.ANR;
	public reportsLinks = [];
	
	constructor(
		private router: Router,
		public tooltipSvc: TooltipService,
		authSvc: AuthenticationService
	) {
    this.activeRoute = this.router.routerState;
		this.router.events.subscribe(e => {
			if(NavigationEnd.prototype.isPrototypeOf(e)){
				this.activeRoute = this.router.routerState;
			}
		});

		authSvc.currentIdentity.subscribe(identity => {
			this.reportsLinks = [
				{
					url: 'my-direct-reports',
					label: 'My Direct Reports',
				},
				{
					url: 'my-supervisors',
					label: 'My Supervisors',
				}
			];

			identity.doWithValue((i: AuthenticatedIdentity) => 
				i.user.roles.academic.doWithValue((a: Academic) =>
				{
					if(a.title.id != AcademicTitleId.CESpecialistSupervisor){
						this.reportsLinks.push({url: 'my-pb-data/themes', label: 'Submit/Export My Project Board Data'});
						
					}else{
						this.router.navigate(['academic', 'review-and-compile', 'my-direct-reports']);
						this.urlIsActive('my-direct-reports');
					}
				}))
		});
	}

	getInstructions(): string {
		return this.tooltipSvc.tooltip("ReviewAndCompileInstructions." + this.tooltipSvc.mapMeritAndPromotionsHRToString(this.meritAndPromotionHR));
	}

	urlIsActive(url: string){
		if(!this.activeRoute){
			return false;
		}
		if(url.indexOf('/') > -1){
			url = url.substring(0, url.indexOf('/'));
		}

		return this.activeRoute.snapshot.url.indexOf(url) > -1;
	}

}